import React from 'react';
import Single from '../assets/single.png';
import Double from '../assets/double.png';
import Triple from '../assets/triple.png';

const Cards = () => {
  return (
    <div className="w-full py-[10rem] px-4 bg-white">
      <div className="max-w-[1240px] mx-auto grid md:grid-cols-3 gap-8">
        <div className="w-full shadow-xl flex flex-col p-4 my-4 rounded-lg hover:scale-105 duration-300">
          <img
            className="w-20 mx-auto mt-[-3rem] bg-white"
            src="https://cdn-icons-png.flaticon.com/512/32/32339.png"
            alt="/"
          />
          <h2 className="text-2xl font-bold text-center py-8">
            Плюсы приложения
          </h2>
          <p className="text-center text-1xl font-bold">
            Помогает легче и интереснее узнавать усваивать новую информацию
          </p>
          <div className="text-center font-medium">
            <p className="py-2 border-b mx-8 mt-8">
              предлагает увлекательный и захватывающий игровой опыт, где игроки
              могут наслаждаться прекрасно оформленными уровнями, разнообразными
              задачами и возможностями
            </p>
            <p className="py-2 border-b mx-8">
              дает возможность обучаться дистанционно и получать знания онлайн
            </p>
            <p className="py-2 border-b mx-8">
              дает возможность автоматизировать процесс обучения
            </p>
          </div>
        </div>
        <div className="w-full shadow-xl bg-gray-100 flex flex-col p-4 md:my-0 my-8 rounded-lg hover:scale-105 duration-300">
          <img
            className="w-20 mx-auto mt-[-3rem] bg-transparent"
            src={Double}
            alt="/"
          />
          <h2 className="text-2xl font-bold text-center py-8">
            Обучающий контент
          </h2>
          <p className="text-center text-2xl font-bold">на учебных занятиях</p>
          <div className="text-center font-medium">
            <p className="py-2 border-b mx-8 mt-8">
              на внеурочных мероприятиях
            </p>
          </div>
        </div>
        <div className="w-full shadow-xl flex flex-col p-4 my-4 rounded-lg hover:scale-105 duration-300">
          <img
            className="w-20 mx-auto mt-[-3rem] bg-white"
            src={Triple}
            alt="/"
          />
          <h2 className="text-2xl font-bold text-center py-8">Аудитория</h2>
          <p className="text-center text-4xl font-bold"> 7-9 лет - дети</p>
          <div className="text-center font-medium">
            <p className="py-2 border-b mx-8 mt-8">
              10-13 лет - ранние подростки.{' '}
            </p>
            <p className="py-2 border-b mx-8">14-18 лет - подростки</p>
            <p className="py-2 border-b mx-8">19-24 - молодежь</p>
            <p className="py-2 border-b mx-8">25-35 - взрослые</p>
            <p className="py-2 border-b mx-8">36-50 – зрелая аудитория. </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cards;
